//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector, useAppDispatch } from 'hooks/redux.hooks';
import { getNewBeneficiary } from 'state/reducers/beneficiary.reducers';
//services
import { loadBeneficiaries } from 'services/beneficiary.services';
//components
import { FormsStack } from 'theme/elements/Forms';
import { MessageCard } from 'theme/elements/Cards';
import { HeaderPage1 } from 'theme/elements/Headers';
import { CenteredText } from 'theme/elements/Content';
//mui
import { Button, Stack } from '@mui/material';
import { FormButton } from 'theme/elements/Buttons';
import { pagesEnum } from 'constants/ui.constants';
import { useNavigate } from 'react-router-dom';
import { Beneficiary, BeneficiaryStatus } from 'constants/beneficiary.constants';
import { SuccessIconMessage } from 'theme/elements/Icons';
import _ from 'lodash';
import { useMemo } from 'react';
import { getMobile } from 'state/reducers/ui.reducers';

export default function Step4(params: { beneficiaries: Beneficiary[] }) {
  const t = useAppSelector(selectTranslations);
  const dispatch = useAppDispatch();
  const beneficiary = useAppSelector(getNewBeneficiary);
  const prefixFields = 'page.beneficiary.create.step.4.';
  const status = _.includes([BeneficiaryStatus.Approved, BeneficiaryStatus.ApprovedWithRisk], beneficiary.status)
    ? `${prefixFields}beneficiary_created.`
    : `${prefixFields}beneficiary_created_and_need_approve.`;
  const navigate = useNavigate();
  const isPayDisabled = useMemo(() => beneficiary.status !== BeneficiaryStatus.Approved, [beneficiary]);
  const isMobile = useAppSelector(getMobile);

  return (
    <FormsStack>
      <MessageCard>
        <CenteredText>
          <SuccessIconMessage />
          <HeaderPage1 title={t(`${status}title`)} text={t(`${status}text`)} />
        </CenteredText>
      </MessageCard>
      <Stack justifyContent="space-between" display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
        <FormButton>
          <Button
            className={isMobile ? 'singleFormButton' : ''}
            variant="text"
            onClick={() => {
              navigate(`/${pagesEnum.BENEFICIARY}`);
            }}
          >
            {t(`${prefixFields}done_button.text`)}
          </Button>
        </FormButton>
        <Stack
          justifyContent="space-between"
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 2, sm: 1 }}
        >
          <FormButton>
            <Button
              className={isMobile ? 'singleFormButton' : ''}
              variant="outlined"
              onClick={() => {
                dispatch(loadBeneficiaries());
                navigate(`/${pagesEnum.BENEFICIARY}/details/${beneficiary.id}`);
              }}
            >
              {t(`${prefixFields}view_profile_button.text`)}
            </Button>
          </FormButton>
          <FormButton sx={{ marginLeft: '8px' }}>
            <Button
              className={isMobile ? 'singleFormButton' : ''}
              variant="contained"
              onClick={() => {
                navigate(`/${pagesEnum.PAY}/new/${beneficiary.id}`);
              }}
              disabled={isPayDisabled}
            >
              {t(`${prefixFields}pay_button.text`)}
            </Button>
          </FormButton>
        </Stack>
      </Stack>
    </FormsStack>
  );
}
